import { array, enums, type Infer, nullable, object, string } from "superstruct";

import { PartyAttributeType } from "@mpa/platform/enums/PartyAttributeType";

import getEnumValues from "../enums/getEnumValues.js";
import { deserializeIsoDate, isoDate, serializeIsoDate } from "../scalar_types/isoDate.js";

export const PartyInfoSerializedSchema = object({
    id: nullable(string()),
    createdAt: nullable(isoDate),
    type: enums(getEnumValues(PartyAttributeType)),
    value: string(),
});

export type PartyInfoSerialized = Infer<typeof PartyInfoSerializedSchema>;

export const PartyInfosSerializedSchema = array(PartyInfoSerializedSchema);

export class PartyInfo {
    id: string | null = null;
    createdAt: Date | null = null;
    type!: PartyAttributeType;
    value = "";

    serialize(): PartyInfoSerialized {
        return {
            id: this.id,
            createdAt: serializeIsoDate(this.createdAt),
            type: this.type,
            value: this.value,
        };
    }

    static deserialize(data: PartyInfoSerialized): PartyInfo {
        const info = new PartyInfo();
        info.id = data.id;
        info.createdAt = deserializeIsoDate(data.createdAt);
        info.type = data.type;
        info.value = data.value;
        return info;
    }

    static find(infos: PartyInfo[], type: PartyAttributeType) {
        return infos.find((info) => info.type === type);
    }
}

export default class Party {
    id: string | null = null;
    createdAt: Date | null = null;
    infos: PartyInfo[] = [];

    findId() {
        if (this.id === null) throw new Error(`${this.constructor.name} has no id`);
        return this.id;
    }

    protected serializeInfos(): PartyInfoSerialized[] {
        return this.infos.map((info) => info.serialize());
    }

    protected loadInfos(infos: PartyInfoSerialized[]) {
        this.infos = infos.map((info) => PartyInfo.deserialize(info));
    }
}
